<template>
  <b-card>
    <b-card-title
      class="text-center"
      style="
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;"
    >
      {{ entity.name.en }}
    </b-card-title>
    <b-card-text>
      <b-button
        variant="primary"
        block
        @click="$emit('review')"
      >
        Review
      </b-button>
    </b-card-text>
  </b-card>
</template>

<script>
import {
  BCard, BCardText, BCardTitle, BButton,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BCardText,
    BCardTitle,
    BButton,
  },
  props: {
    entity: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style></style>
